import { RootState } from '../../Store'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { offerHasSapContract } from 'app/app/(client)/nemo/offer'
import { getUpdatedOfferFields } from 'app/app/(client)/nemo/offer/reset'
import { Offer } from 'app/types/types'
import { showAlert } from '../notification/alert-slice'
import { errorAlert } from '../notification/modal-state'
import { updateOfferAsync } from './update-offer-async'
import { t } from 'i18next'

interface ValidateOfferUpdatePayload {
  onSuccess: (offer?: Offer) => void
  onFailure?: () => void
  suppressCompletedOfferDialog?: boolean
  isEscalationFlowSwitch?: boolean
}

export const validateOfferUpdate = createAsyncThunk<void, ValidateOfferUpdatePayload, { state: RootState }>(
  'currentOffer/validateOfferUpdate',
  async ({ onSuccess, onFailure, suppressCompletedOfferDialog = false, isEscalationFlowSwitch = false }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI
    const state = getState()
    const offer = state.currentOffer.data
    const frontlineConfig = state.configdata.data?.frontLineConfig

    if (!offer || !dispatch) {
      if (onFailure) {
        onFailure()
      }
      return
    }

    if (offerHasSapContract(offer)) {
      dispatch(showAlert({ ...errorAlert(dispatch, t('offerWizard.summary.lockedSAPOffer')) }))
      if (onFailure) {
        onFailure()
      }
    } else if (offer.sapOIStartTimestamp) {
      dispatch(showAlert({ ...errorAlert(dispatch, t('contract.sapPleaseWait')) }))
      if (onFailure) {
        onFailure()
      }
    } else if (offer.finalized) {
      const onPrimary = async () => {
        if (frontlineConfig) {
          const updatedFields = getUpdatedOfferFields(offer, frontlineConfig)
          const updatedOffer: Offer = { ...offer, ...updatedFields }
          await dispatch(updateOfferAsync(_ => updatedOffer))
          const latestOffer = getState().currentOffer.data
          onSuccess(latestOffer)
        } else {
          onSuccess(offer)
        }
      }

      const onCancel = () => {
        if (onFailure) {
          onFailure()
        }
      }

      if (!suppressCompletedOfferDialog) {
        dispatch(
          showAlert({
            ...errorAlert(
              dispatch,
              t('offerWizard.summary.lockedOffer'),
              t('offerWizard.summary.confirm'),
              onCancel,
              onPrimary
            )
          })
        )
      } else if (isEscalationFlowSwitch) {
        onSuccess()
      } else {
        onPrimary()
      }
    } else if (offer.completed && !offer.finalized) {
      dispatch(showAlert({ ...errorAlert(dispatch, t('offerWizard.summary.lockedSyncing')) }))
      if (onFailure) {
        onFailure()
      }
    } else {
      onSuccess()
    }
  }
)
